<template>
  <CCard>
    <CCardHeader v-if="headerHtml" v-html="headerHtml"></CCardHeader>
    <CCardBody class="p-2">
      <CRow>
        <CCol col="12" xxl="4">
          <CRow>
            <template v-if="status != null">
              <CCol
                col="6"
                sm="3"
                xl="2"
                xxl="4"
                v-for="(item, index) in status.stateList"
                :key="index"
              >
                <div
                  class="d-flex flex-column p-3"
                  :style="
                    status.control.mode.value === 'dashboard'
                      ? 'cursor: pointer'
                      : ''
                  "
                  @click="showControlModal(item)"
                >
                  <VueSvgGauge
                    :start-angle="-120"
                    :end-angle="120"
                    :value="getGaugeValue(item.value)"
                    :separator-step="0"
                    :min="0"
                    :max="100"
                    :gauge-color="getGaugeColor(item.status)"
                    :scale-interval="0.1"
                  >
                    <div class="inner-text">
                      <span style="margin-top: 20px">
                        {{ getGaugeValue(item.value) }}%
                      </span>
                    </div>
                  </VueSvgGauge>
                  <div
                    class="label bg-color-blue-light scc-rounded pl-2 pr-2 w-100 text-center mt-2"
                  >
                    {{ item.name }}
                  </div>
                </div>
              </CCol>
            </template>
          </CRow>
        </CCol>
        <CCol col="12" xxl="8">
          <div class="control-panel">
            <img :src="app.getUrl('img/bg_house.png')" />
            <div class="control-card" style="left: 15%; top: 60%">
              <div class="control-card-header">유동팬</div>
              <div class="control-card-body">
                <span style="vertical-align: middle"> 작동 </span>
                <CSwitch
                  :disabled="mode === 'site'"
                  :checked.sync="floatingFan"
                  class="mx-1"
                  color="info"
                  variant="3d"
                  v-bind="{
                    labelOn: 'ON',
                    labelOff: 'OFF',
                  }"
                  style="vertical-align: middle"
                />
              </div>
            </div>
            <div class="control-card" style="left: 30%; top: 30%">
              <div class="control-card-header">배기팬</div>
              <div class="control-card-body">
                <span style="vertical-align: middle"> 작동 </span>
                <CSwitch
                  :disabled="mode === 'site'"
                  :checked.sync="exhaustFan"
                  class="mx-1"
                  color="info"
                  variant="3d"
                  v-bind="{
                    labelOn: 'ON',
                    labelOff: 'OFF',
                  }"
                  style="vertical-align: middle"
                />
              </div>
            </div>
            <div
              class="control-card"
              style="left: 50%; top: initial; bottom: 10%"
            >
              <div class="control-card-header">난방기</div>
              <div class="control-card-body">
                <span style="vertical-align: middle"> 작동 </span>
                <CSwitch
                  :disabled="mode === 'site'"
                  :checked.sync="heater"
                  class="mx-1"
                  color="info"
                  variant="3d"
                  v-bind="{
                    labelOn: 'ON',
                    labelOff: 'OFF',
                  }"
                  style="vertical-align: middle"
                />
              </div>
            </div>
            <div
              class="control-card"
              style="left: initial; right: 10%; top: 45%"
            >
              <div class="control-card-header">포그기</div>
              <div class="control-card-body">
                <span style="vertical-align: middle"> 작동 </span>
                <CSwitch
                  :disabled="mode === 'site'"
                  :checked.sync="fog"
                  class="mx-1"
                  color="info"
                  variant="3d"
                  v-bind="{
                    labelOn: 'ON',
                    labelOff: 'OFF',
                  }"
                  style="vertical-align: middle"
                />
              </div>
            </div>
            <div
              class="control-card"
              style="left: initial; right: 10%; top: 5%; width: 140px"
            >
              <div class="control-card-header">카메라</div>
              <div class="control-card-body">
                <div>
                  <span style="vertical-align: middle"> 상승 </span>
                  <CSwitch
                    :disabled="mode === 'site'"
                    :checked.sync="cameraUp"
                    class="mx-1"
                    color="info"
                    variant="3d"
                    v-bind="{
                      labelOn: 'ON',
                      labelOff: 'OFF',
                    }"
                    style="vertical-align: middle"
                  />
                </div>
                <div class="mt-2">
                  <span style="vertical-align: middle"> 하강 </span>
                  <CSwitch
                    :disabled="mode === 'site'"
                    :checked.sync="cameraDown"
                    class="mx-1"
                    color="info"
                    variant="3d"
                    v-bind="{
                      labelOn: 'ON',
                      labelOff: 'OFF',
                    }"
                    style="vertical-align: middle"
                  />
                </div>
              </div>
            </div>
          </div>
        </CCol>
      </CRow>
    </CCardBody>

    <switch-control-modal
      :properties="modal.switch"
      v-if="modal.switch.visible"
    ></switch-control-modal>
  </CCard>
</template>

<script>
import core from "@/core";
import ControlService from "@/services/control/control.service";
import SwitchControlModal from "@/modals/control/SwitchControlModal";
import store from "@/store";

export default {
  name: "ControlCard",
  components: { SwitchControlModal },
  props: {
    headerHtml: null,
  },
  data() {
    return {
      app: store.state.app,
      mode: "site",
      floatingFan: false,
      exhaustFan: false,
      heater: false,
      fog: false,
      cameraUp: false,
      cameraDown: false,

      status: null,
      modal: {
        switch: {
          visible: false,
          params: {},
          watchClose: {},
        },
      },
    };
  },

  async mounted() {
    const vm = this;

    function call() {
      setTimeout(async () => {
        try {
          vm.status = await ControlService.getNareData();
          if (!vm._isDestroyed) {
            call();
          }
        } catch (e) {
          console.log(e);
          if (!vm._isDestroyed) {
            call();
          }
        }
      }, 2500);
    }

    call();
    try {
      this.status = await ControlService.getNareData();
    } catch (e) {
      console.log(e);
    }
  },
  watch: {
    status(status) {
      if (status != null) {
        this.mode = status.control.mode.value;
        this.floatingFan = status.relay.floatingFan.on;
        this.exhaustFan = status.relay.exhaustFan.on;
        this.heater = status.relay.heater.on;
        this.fog = status.relay.fog.on;
        this.cameraUp = status.relay.cameraUp.on;
        this.cameraDown = status.relay.cameraDown.on;

        const modal = this.modal.switch;
        if (modal.visible) {
          const item = modal.params.item;
          if (item != null) {
            modal.params = { item: status[item.type][item.key] };
          }
        }
        this.$emit("update:status", status);
      }
      //console.log("status : ", status);
    },
    floatingFan(on) {
      if (this.status != null && this.status.relay.floatingFan.on !== on) {
        this.controlNareRelay(this.status.relay.floatingFan, on);
      }
    },
    exhaustFan(on) {
      if (this.status != null && this.status.relay.exhaustFan.on !== on) {
        this.controlNareRelay(this.status.relay.exhaustFan, on);
      }
    },
    heater(on) {
      if (this.status != null && this.status.relay.heater.on !== on) {
        this.controlNareRelay(this.status.relay.heater, on);
      }
    },
    fog(on) {
      if (this.status != null && this.status.relay.fog.on !== on) {
        this.controlNareRelay(this.status.relay.fog, on);
      }
    },
    cameraUp(on) {
      if (this.status != null && this.status.relay.cameraUp.on !== on) {
        this.controlNareRelay(this.status.relay.cameraUp, on);
      }
    },
    cameraDown(on) {
      if (this.status != null && this.status.relay.cameraDown.on !== on) {
        this.controlNareRelay(this.status.relay.cameraDown, on);
      }
    },
  },
  methods: {
    getGaugeColor(status) {
      if (status === "open") return "#2d6ba6";
      else if (status === "close") return "#9e0625";
      else if (status === "stop") return "#459245";
      else return "#000000";
    },
    getGaugeValue(value) {
      if (value < 0) return 0;
      else if (100 < value) return 100;
      return value;
    },
    async changeControlMode(value) {
      try {
        core.loader.show("제어중...");
        const result = await ControlService.controlNareMode(value);
        console.log("result : ", result);
        core.loader.hide();
      } catch (e) {
        console.log(e);
      }
    },
    showControlModal(item) {
      if (this.status.control.mode.value === "dashboard") {
        const modal = this.modal.switch;
        modal.params.item = item;
        modal.visible = true;
        console.log("control : ", item);
      }
    },
    async controlNareRelay(item, on) {
      try {
        core.loader.show("제어중...");

        // console.log("control : ", item);
        const result = await ControlService.controlNareRelay(item, on);
        // console.log("result : ", result);
        core.loader.hide();
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
